<template>
  <div class="collection-info-box">
    <div class="collection-info">
      <div class="collection-details">
        <h3 class="collection-name">{{ collectionName }}</h3>
        <p class="collection-count">{{ fileCount }} {{ fileCount === 1 ? 'file' : 'files' }}</p>
      </div>
      <div class="collection-actions">
        <q-btn flat dense class="share-btn" icon="o_link" label="Share Link" @click.stop="handleShare" :loading="isSharing" no-caps />
      </div>
    </div>

    <!-- Share Content Dialog -->
    <ShareContentDialog
      :show="showShareDialog"
      @update:show="handleShareDialogClose"
      :collection-id="collectionId"
      :collection-name="collectionName"
      :content-ids="contentIds"
      share-type="collection"
    />
  </div>
</template>

<script>
import ShareContentDialog from '@/components/gallery/ShareContentDialog.vue';

export default {
  name: 'CollectionInfoBox',

  components: {
    ShareContentDialog
  },

  props: {
    collectionId: {
      type: [String, Number],
      required: true
    },
    collectionName: {
      type: String,
      required: true
    },
    fileCount: {
      type: Number,
      default: 0
    },
    contentIds: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      showShareDialog: false,
      isSharing: false
    };
  },

  methods: {
    handleShare() {
      this.$nextTick(() => {
        this.showShareDialog = true;
        this.isSharing = false;
      });
    },

    handleShareDialogClose(value) {
      this.showShareDialog = typeof value === 'boolean' ? value : false;
      this.isSharing = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.collection-info-box {
  width: 100%;
  padding: 12px 16px;
  background: rgba(248, 249, 250, 0.6);
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.collection-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.collection-details {
  flex: 1;
  text-align: left;
}

.collection-name {
  @include mona-sans-font($size: 16px, $bolded: true, $color: var(--main-text-color));
  margin: 0 0 2px 0;
  line-height: 1.2;
  text-align: left;
}

.collection-count {
  @include inter-font($size: 12px, $color: var(--secondary-text-color));
  margin: 0;
  text-align: left;
}

.collection-actions {
  display: flex;
  align-items: center;
}

.share-btn {
  @include inter-font($size: 14px, $bolded: true, $color: var(--secondary-text-color));
  height: 44px;
  border-radius: 8px;
  padding: 0 16px;
  background-color: var(--terziary-btn-color);
  box-shadow: none;

  .q-icon {
    margin-right: 8px;
    font-size: 18px;
    color: var(--secondary-text-color);
  }
}
</style>
